import { render, staticRenderFns } from "./IpoPortfolioRow.vue?vue&type=template&id=160a11ee"
import script from "./IpoPortfolioRow.vue?vue&type=script&lang=js"
export * from "./IpoPortfolioRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports